import { LiveEventAction, LiveEventActionError, UserRole } from 'types';
import { eventSessionSelector, isAuthSelector, userRoleSelector } from 'store/selectors';

import { useStore } from './utils';

const useLiveEventActions = (eventCode: string) => {
  const isAuth = useStore(isAuthSelector);
  const eventSession = useStore(eventSessionSelector(eventCode));
  const userRole = useStore(userRoleSelector(eventCode, eventSession.username));
  const actions: Record<UserRole, { [value in LiveEventAction]?: boolean }> = {
    [UserRole.HOST]: {
      [LiveEventAction.TOGGLE_HAND_RAISE_PERMISSION]: isAuth,
      [LiveEventAction.REJECT_HAND_RAISE_REQUEST]: isAuth,
      [LiveEventAction.APPROVE_HAND_RAISE_REQUEST]: isAuth,
      [LiveEventAction.PROMOTE_SPEAKER]: isAuth,
      [LiveEventAction.DEMOTE_MODERATOR]: isAuth,
      [LiveEventAction.FORCE_MUTE_SPEAKER]: true,
      [LiveEventAction.REMOVE_SPEAKER_FROM_STAGE]: isAuth,
      [LiveEventAction.GENERATE_INVITATION_LINK]: isAuth,
      [LiveEventAction.INVITE_VIEWER_TO_STAGE]: isAuth
    },
    [UserRole.MODERATOR]: {
      [LiveEventAction.TOGGLE_HAND_RAISE_PERMISSION]: true,
      [LiveEventAction.REJECT_HAND_RAISE_REQUEST]: true,
      [LiveEventAction.APPROVE_HAND_RAISE_REQUEST]: true,
      [LiveEventAction.PROMOTE_SPEAKER]: true,
      [LiveEventAction.DEMOTE_MODERATOR]: true,
      [LiveEventAction.FORCE_MUTE_SPEAKER]: true,
      [LiveEventAction.REMOVE_SPEAKER_FROM_STAGE]: true,
      [LiveEventAction.GENERATE_INVITATION_LINK]: true,
      [LiveEventAction.INVITE_VIEWER_TO_STAGE]: true
    },
    [UserRole.SPEAKER]: {},
    [UserRole.VIEWER]: {
      [LiveEventAction.RAISE_HAND]: isAuth,
      [LiveEventAction.DROP_HAND]: isAuth
    }
  };

  const hasPermission = (action: LiveEventAction): boolean => action in actions[userRole];

  const attempt = async (action: LiveEventAction) => {
    if (actions[userRole][action] === false) {
      if (!isAuth) throw Error(LiveEventActionError.AUTH_REQUIRED);
    }
  };

  return { hasPermission, attempt };
};

export default useLiveEventActions;
